// Brand reducer
const initialState = {
  currentBrand: "termovent", // default brand
  isClivet: false,
  isProlux: false,
};

const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BRAND":
      return {
        ...state,
        currentBrand: action.payload,
        isClivet: action.payload === "clivet",
        isProlux: action.payload === "prolux",
      };
    case "DETECT_BRAND":
      return {
        ...state,
        currentBrand: action.payload,
        isClivet: action.payload === "clivet",
        isProlux: action.payload === "prolux",
      };
    default:
      return state;
  }
};

export default brandReducer;
